import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import {
    FaltaCadastrada,
    faltasCadastradas,
} from 'service/api/endpoints/faltas-cadastradas'
import { toast } from 'sonner'
import FormEditarFaltaCadastrada from '../forms/EditarFaltaCadastrada'
import {
    useDigitacaoDataContext,
    useUpdateDigitacaoQueryData,
} from '../pages/useDigitacaoData'
import ExcluirFaltaCadastrada from './ExcluirFaltaCadastrada'

export default function DetalhesFaltaCadastradaDigitacao() {
    const { mutateAsync } = faltasCadastradas.mutations.useUpdate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { id } = useParams()
    const [open, setOpen] = useState(false)
    const {
        context: { data },
    } = useDigitacaoDataContext()

    const falta = data.find(
        ({ faltaCadastrada }) => faltaCadastrada?.id === Number(id),
    )?.faltaCadastrada

    if (!falta) return null

    const handleSubmit: SubmitHandler<FaltaCadastrada> = data =>
        mutateAsync(
            {
                ...data,
                data: dayjs(data.data).toDate(),
            },
            {
                onSuccess: res => {
                    setQueryData('FALTA_CADASTRADA', res)
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            disableFields={
                !hasPermission(['update', 'FaltasJustificadasOuInjustificadas'])
            }
            defaultValues={{
                ...falta,
                isInjustificada: !falta.justificativa,
                isReadOnly: true,
            }}
            height="auto"
            width="45rem"
            onSubmit={
                hasPermission(['update', 'FaltasJustificadasOuInjustificadas'])
                    ? handleSubmit
                    : undefined
            }
        >
            <Dialog.Title>
                Detalhes da falta{' '}
                {falta.justificativa ? 'justificada' : 'injustificada'}
            </Dialog.Title>
            <Dialog.Content dividers>
                <FormEditarFaltaCadastrada />
                <ExcluirFaltaCadastrada
                    open={open}
                    onClose={() => setOpen(false)}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                {hasPermission(
                    ['delete', 'FaltasJustificadasOuInjustificadas'],
                    () => (
                        <Dialog.Actions.PrimaryButton
                            color="error"
                            onClick={() => setOpen(true)}
                        >
                            Excluir
                        </Dialog.Actions.PrimaryButton>
                    ),
                )}
                {hasPermission(
                    ['update', 'FaltasJustificadasOuInjustificadas'],
                    () => (
                        <Dialog.Actions.PrimaryButton closeOnSubmit />
                    ),
                )}
            </Dialog.Actions>
        </Dialog.Root>
    )
}
